import React from "react";
import Card from "@material-ui/core/Card";

function TableCard(props) {
  return <Card {...props} style={{ display: "block", height: "100%" }} />;
}

export default TableCard;
